import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from '../../utils/constants';
import { useUserDetails } from '../../recoil/hooks/useUserState';

// Mock implementations for sister project - replace with actual implementations
const mockRoutes = {
  dashboard: `${API_ENDPOINTS.fe}dashboard`,
  assets: `${API_ENDPOINTS.fe}assets`,
  ordersHistory: `${API_ENDPOINTS.fe}order-history`,
  identification: `${API_ENDPOINTS.fe}identification`,
  settings: `${API_ENDPOINTS.fe}settings`,
  security: `${API_ENDPOINTS.fe}security`,
  rewards: `${API_ENDPOINTS.fe}rewards`,
};

// Open link in a new tab
const navigateTo = (path: string) => (e: React.MouseEvent) => {
  e.preventDefault();
  // Open in new tab and prevent access to window.opener
  window.open(path, '_blank', 'noopener,noreferrer');
};


const useGlobalLoading = () => {
  const [loading, setLoading] = useState(false);
  return [loading, setLoading] as const;
};

const usePerformLogin = () => {
  const [perform, setPerform] = useState<any>(null);
  return [perform, setPerform] as const;
};

// Mock service - replace with actual implementation
const logoutUser = async (): Promise<void> => {
  const accessToken = localStorage.getItem('accessToken');
  const baseUrl = API_ENDPOINTS?.base ?? '';
  try {
    const axios = (await import('axios')).default;
    await axios.get(`${baseUrl}v0/auth/logout`, {
      headers: {
        Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
        Accept: '*/*',
      },
    });
  } catch (err) {
    console.error('Logout request failed:', err);
    // proceed to clear local state even if logout request fails
  } finally {
    // Clear local auth state
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');

    // Reset any global/module state if present (no-ops if not)
    try {
      (window as any).privateToken = null;
      (window as any).instanceEndpoint = null;
      (window as any).isBalanceSocketConnected = false;
    } catch {
      // ignore
    }
  }
};

// Mock utility functions - replace with actual implementations
const clearAccessToken = () => {
  localStorage.removeItem('accessToken');
  console.log("cleared access token")
};

const clearRefreshToken = () => {
  localStorage.removeItem('refreshToken');
};

const handleHrefNavToSilent = (navigate: any) => (path: string) => (e: React.MouseEvent) => {
  e.preventDefault();
  navigate(path);
};

// ID Verification Badge Component
export const IDVerificationBadge = () => {
  return <div className='bg-[#01bc8d14] px-3 py-[4px] text-f12 font-semibold rounded-[4px] text-[#00c288] flex justify-start items-center gap-3'>

    <svg
      width="16px"
      height="16px"
      viewBox="0 0 22 22"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      <path
        d="M10.401 0.794778C10.7011 0.396626 11.2989 0.396625 11.599 0.794778L12.9886 2.6388C13.1879 2.90318 13.5369 3.00566 13.8474 2.89097L16.0135 2.091C16.4812 1.91827 16.9841 2.24147 17.0212 2.73864L17.1934 5.04126C17.218 5.37139 17.4562 5.64629 17.7795 5.7177L20.0342 6.21577C20.521 6.32331 20.7693 6.86709 20.5318 7.30543L19.4317 9.33557C19.274 9.62663 19.3258 9.98668 19.5591 10.2215L21.1866 11.8595C21.538 12.2132 21.4529 12.8049 21.0161 13.0452L18.9931 14.1583C18.703 14.3179 18.5519 14.6488 18.6213 14.9725L19.1048 17.2303C19.2092 17.7178 18.8178 18.1696 18.3204 18.1357L16.0167 17.9783C15.6864 17.9558 15.3804 18.1524 15.2637 18.4622L14.4498 20.6231C14.2741 21.0897 13.7005 21.2581 13.3004 20.9606L11.4475 19.5828C11.1819 19.3852 10.8181 19.3852 10.5525 19.5828L8.69955 20.9606C8.29948 21.2581 7.72589 21.0897 7.55016 20.6231L6.73628 18.4622C6.6196 18.1524 6.3136 17.9558 5.98332 17.9783L3.67964 18.1357C3.18224 18.1696 2.79076 17.7178 2.89517 17.2303L3.37874 14.9725C3.44807 14.6488 3.29697 14.3179 3.00692 14.1583L0.983894 13.0452C0.547091 12.8049 0.462014 12.2132 0.813412 11.8595L2.44089 10.2215C2.67423 9.98668 2.72599 9.62664 2.56827 9.33557L1.46819 7.30543C1.23066 6.86709 1.479 6.32331 1.96582 6.21577L4.2205 5.7177C4.54376 5.64629 4.78196 5.37139 4.80664 5.04126L4.97876 2.73864C5.01593 2.24147 5.51884 1.91827 5.98652 2.091L8.15255 2.89097C8.4631 3.00566 8.81211 2.90318 9.01135 2.6388L10.401 0.794778Z"
        fill="currentColor"
      />
      <path
        opacity="0.9"
        d="M6.46921 10.1359C6.94653 9.65862 7.72039 9.65862 8.19771 10.1359L9.77791 11.7161L13.8026 7.69147C14.2798 7.21417 15.0537 7.21417 15.531 7.69147C16.0083 8.16879 16.0083 8.94265 15.531 9.41996L10.6421 14.3088C10.1648 14.7861 9.39097 14.7861 8.91366 14.3088L6.46921 11.8644C5.99191 11.3871 5.99191 10.6132 6.46921 10.1359Z"
        fill="#000"
      />
    </svg>
    Verified
  </div>;
};

// Individual Menu Item Component
const MenuItem = ({
  icon,
  text,
  onClick,
  badge,
  className = ""
}: {
  icon: React.ReactNode;
  text: string;
  onClick: (e: React.MouseEvent) => void;
  badge?: React.ReactNode;
  className?: string;
}) => {
  return (
    <button
      onClick={onClick}
      className={`w-full flex items-center gap-3 px-4 py-2 text-left text-[#4b5563] dark:text-gray-300 dark:hover:bg-gray-700 transition-colors duration-150 ${className}`}
    >
      <div className="w-6 h-6 flex items-center justify-center">
        {icon}
      </div>
      <span className="text-f14 font-normal ">{text}</span>
      {badge}
    </button>
  );
};

// Main Menu Popup Component
export default function MenuPopupTailwind() {
  const navigate = useNavigate();
  const handleHrefNav = handleHrefNavToSilent(navigate);
  const [user, setUser] = useUserDetails();
  const [loading, setLoading] = useGlobalLoading();
  const [perform, setPerform] = usePerformLogin();

  const handleLogout = (e: React.MouseEvent) => {
    setPerform(null); // clear any ongoing login process
    e.preventDefault();
    setLoading(true);
    logoutUser().then(res => {
      // Handle successful logout
    }).catch(err => {
      console.error(err);
    }).finally(() => {
      setUser(null);
      clearAccessToken();
      clearRefreshToken();
      setLoading(false);
      console.log("called logout")
    });
  };

  const menuItems = [
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '4px' }}
          xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.4"
            d="M18.6699 2H16.7699C14.5899 2 13.4399 3.15 13.4399 5.33V7.23C13.4399 9.41 14.5899 10.56 16.7699 10.56H18.6699C20.8499 10.56 21.9999 9.41 21.9999 7.23V5.33C21.9999 3.15 20.8499 2 18.6699 2Z"
            fill="currentColor" />
          <path opacity="0.4"
            d="M7.24 13.4301H5.34C3.15 13.4301 2 14.5801 2 16.7601V18.6601C2 20.8501 3.15 22.0001 5.33 22.0001H7.23C9.41 22.0001 10.56 20.8501 10.56 18.6701V16.7701C10.57 14.5801 9.42 13.4301 7.24 13.4301Z"
            fill="currentColor" />
          <path
            d="M6.29 10.58C8.6593 10.58 10.58 8.6593 10.58 6.29C10.58 3.9207 8.6593 2 6.29 2C3.9207 2 2 3.9207 2 6.29C2 8.6593 3.9207 10.58 6.29 10.58Z"
            fill="currentColor" />
          <path
            d="M17.7099 22C20.0792 22 21.9999 20.0793 21.9999 17.71C21.9999 15.3407 20.0792 13.42 17.7099 13.42C15.3406 13.42 13.4199 15.3407 13.4199 17.71C13.4199 20.0793 15.3406 22 17.7099 22Z"
            fill="currentColor" />
        </svg>
      ),
      text: 'Dashboard',
      onClick: navigateTo(mockRoutes.dashboard),
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '4px' }}
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.0602 11.8201L20.9002 11.6001C20.6202 11.2601 20.2902 10.9901 19.9102 10.7901C19.4002 10.5001 18.8202 10.3501 18.2202 10.3501H5.7702C5.1702 10.3501 4.6002 10.5001 4.0802 10.7901C3.6902 11.0001 3.3402 11.2901 3.0502 11.6501C2.4802 12.3801 2.2102 13.2801 2.3002 14.1801L2.6702 18.8501C2.8002 20.2601 2.9702 22.0001 6.1402 22.0001H17.8602C21.0302 22.0001 21.1902 20.2601 21.3302 18.8401L21.7002 14.1901C21.7902 13.3501 21.5702 12.5101 21.0602 11.8201ZM14.3902 17.3401H9.6002C9.2102 17.3401 8.9002 17.0201 8.9002 16.6401C8.9002 16.2601 9.2102 15.9401 9.6002 15.9401H14.3902C14.7802 15.9401 15.0902 16.2601 15.0902 16.6401C15.0902 17.0301 14.7802 17.3401 14.3902 17.3401Z"
            fill="currentColor" />
          <path opacity="0.4"
            d="M3.37988 11.31C3.59988 11.11 3.81988 10.93 4.07988 10.79C4.58988 10.5 5.16988 10.35 5.76988 10.35H18.2299C18.8299 10.35 19.3999 10.5 19.9199 10.79C20.1799 10.93 20.4099 11.11 20.6199 11.32V10.79V9.82C20.6199 6.25 19.5299 5.16 15.9599 5.16H13.5799C13.1399 5.16 13.1299 5.15 12.8699 4.81L11.6699 3.2C11.0999 2.46 10.6499 2 9.21988 2H8.03988C4.46988 2 3.37988 3.09 3.37988 6.66V10.8V11.31Z"
            fill="currentColor" />
        </svg>
      ),
      text: 'My Asset',
      onClick: navigateTo(mockRoutes.assets),
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '4px' }}
          xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.4"
            d="M6.73049 19.7C7.55049 18.82 8.80049 18.89 9.52049 19.85L10.5305 21.2C11.3405 22.27 12.6505 22.27 13.4605 21.2L14.4705 19.85C15.1905 18.89 16.4405 18.82 17.2605 19.7C19.0405 21.6 20.4905 20.97 20.4905 18.31V7.04C20.5005 3.01 19.5605 2 15.7805 2H8.22049C4.44049 2 3.50049 3.01 3.50049 7.04V18.3C3.50049 20.97 4.96049 21.59 6.73049 19.7Z"
            fill="currentColor" />
          <path
            d="M16.2305 11.75H10.7305C10.3205 11.75 9.98047 11.41 9.98047 11C9.98047 10.59 10.3205 10.25 10.7305 10.25H16.2305C16.6405 10.25 16.9805 10.59 16.9805 11C16.9805 11.41 16.6405 11.75 16.2305 11.75Z"
            fill="currentColor" />
          <path
            d="M16.2305 7.75H10.7305C10.3205 7.75 9.98047 7.41 9.98047 7C9.98047 6.59 10.3205 6.25 10.7305 6.25H16.2305C16.6405 6.25 16.9805 6.59 16.9805 7C16.9805 7.41 16.6405 7.75 16.2305 7.75Z"
            fill="currentColor" />
          <path
            d="M7.78027 8C7.23027 8 6.78027 7.55 6.78027 7C6.78027 6.45 7.23027 6 7.78027 6C8.33027 6 8.78027 6.45 8.78027 7C8.78027 7.55 8.33027 8 7.78027 8Z"
            fill="currentColor" />
          <path
            d="M7.78027 12C7.23027 12 6.78027 11.55 6.78027 11C6.78027 10.45 7.23027 10 7.78027 10C8.33027 10 8.78027 10.45 8.78027 11C8.78027 11.55 8.33027 12 7.78027 12Z"
            fill="currentColor" />
        </svg>
      ),
      text: 'My Orders',
      onClick: navigateTo(mockRoutes.ordersHistory),
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '4px' }}
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18 13C17.06 13 16.19 13.33 15.5 13.88C14.58 14.61 14 15.74 14 17C14 17.75 14.21 18.46 14.58 19.06C15.27 20.22 16.54 21 18 21C19.01 21 19.93 20.63 20.63 20C20.94 19.74 21.21 19.42 21.42 19.06C21.79 18.46 22 17.75 22 17C22 14.79 20.21 13 18 13ZM20.07 16.57L17.94 18.54C17.8 18.67 17.61 18.74 17.43 18.74C17.24 18.74 17.05 18.67 16.9 18.52L15.91 17.53C15.62 17.24 15.62 16.76 15.91 16.47C16.2 16.18 16.68 16.18 16.97 16.47L17.45 16.95L19.05 15.47C19.35 15.19 19.83 15.21 20.11 15.51C20.39 15.81 20.37 16.28 20.07 16.57Z"
            fill="currentColor"></path>
          <path opacity="0.4"
            d="M21.09 21.5C21.09 21.78 20.87 22 20.59 22H3.41003C3.13003 22 2.91003 21.78 2.91003 21.5C2.91003 17.36 6.99003 14 12 14C13.03 14 14.03 14.14 14.95 14.41C14.36 15.11 14 16.02 14 17C14 17.75 14.21 18.46 14.58 19.06C14.78 19.4 15.04 19.71 15.34 19.97C16.04 20.61 16.97 21 18 21C19.12 21 20.13 20.54 20.85 19.8C21.01 20.34 21.09 20.91 21.09 21.5Z"
            fill="currentColor"></path>
          <path
            d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
            fill="currentColor"></path>
        </svg>
      ),
      text: 'Identity',
      onClick: navigateTo(mockRoutes.identification),
      badge: <IDVerificationBadge />,
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '4px' }}
          xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.4"
            d="M2 12.8801V11.1201C2 10.0801 2.85 9.22006 3.9 9.22006C5.71 9.22006 6.45 7.94006 5.54 6.37006C5.02 5.47006 5.33 4.30006 6.24 3.78006L7.97 2.79006C8.76 2.32006 9.78 2.60006 10.25 3.39006L10.36 3.58006C11.26 5.15006 12.74 5.15006 13.65 3.58006L13.76 3.39006C14.23 2.60006 15.25 2.32006 16.04 2.79006L17.77 3.78006C18.68 4.30006 18.99 5.47006 18.47 6.37006C17.56 7.94006 18.3 9.22006 20.11 9.22006C21.15 9.22006 22.01 10.0701 22.01 11.1201V12.8801C22.01 13.9201 21.16 14.7801 20.11 14.7801C18.3 14.7801 17.56 16.0601 18.47 17.6301C18.99 18.5401 18.68 19.7001 17.77 20.2201L16.04 21.2101C15.25 21.6801 14.23 21.4001 13.76 20.6101L13.65 20.4201C12.75 18.8501 11.27 18.8501 10.36 20.4201L10.25 20.6101C9.78 21.4001 8.76 21.6801 7.97 21.2101L6.24 20.2201C5.33 19.7001 5.02 18.5301 5.54 17.6301C6.45 16.0601 5.71 14.7801 3.9 14.7801C2.85 14.7801 2 13.9201 2 12.8801Z"
            fill="currentColor" />
          <path
            d="M12 15.25C13.7949 15.25 15.25 13.7949 15.25 12C15.25 10.2051 13.7949 8.75 12 8.75C10.2051 8.75 8.75 10.2051 8.75 12C8.75 13.7949 10.2051 15.25 12 15.25Z"
            fill="currentColor" />
        </svg>
      ),
      text: 'Account Settings',
      onClick: navigateTo(mockRoutes.settings),
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '4px' }}
          xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.4"
            d="M20.91 11.12C20.91 16.01 17.36 20.59 12.51 21.93C12.18 22.02 11.82 22.02 11.49 21.93C6.63996 20.59 3.08997 16.01 3.08997 11.12V6.73006C3.08997 5.91006 3.70998 4.98007 4.47998 4.67007L10.05 2.39007C11.3 1.88007 12.71 1.88007 13.96 2.39007L19.53 4.67007C20.29 4.98007 20.92 5.91006 20.92 6.73006L20.91 11.12Z"
            fill="currentColor"></path>
          <path
            d="M14.5 10.5C14.5 9.12 13.38 8 12 8C10.62 8 9.5 9.12 9.5 10.5C9.5 11.62 10.24 12.55 11.25 12.87V15.5C11.25 15.91 11.59 16.25 12 16.25C12.41 16.25 12.75 15.91 12.75 15.5V12.87C13.76 12.55 14.5 11.62 14.5 10.5Z"
            fill="currentColor"></path>
        </svg>
      ),
      text: 'Security',
      onClick: navigateTo(mockRoutes.security),
    },
    // {
    //   icon: (
    //     <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
    //       <path opacity="0.4" d="M18 20.5H17V20.25C17 19.15 16.1 18.25 15 18.25H12.75V15.96C12.5 15.99 12.25 16 12 16C11.75 16 11.5 15.99 11.25 15.96V18.25H9C7.9 18.25 7 19.15 7 20.25V20.5H6C5.59 20.5 5.25 20.84 5.25 21.25C5.25 21.66 5.59 22 6 22H18C18.41 22 18.75 21.66 18.75 21.25C18.75 20.84 18.41 20.5 18 20.5Z" fill="currentColor" />
    //       <path opacity="0.4" d="M5.51979 11.64C4.85979 11.39 4.27979 10.98 3.81979 10.52C2.88979 9.49 2.27979 8.26 2.27979 6.82C2.27979 5.38 3.40979 4.25 4.84979 4.25H5.40979C5.14979 4.78 4.99979 5.37 4.99979 6V9C4.99979 9.94 5.17979 10.83 5.51979 11.64Z" fill="currentColor" />
    //       <path opacity="0.4" d="M21.72 6.82C21.72 8.26 21.11 9.49 20.18 10.52C19.72 10.98 19.14 11.39 18.48 11.64C18.82 10.83 19 9.94 19 9V6C19 5.37 18.85 4.78 18.59 4.25H19.15C20.59 4.25 21.72 5.38 21.72 6.82Z" fill="currentColor" />
    //       <path d="M15 2H9C6.79 2 5 3.79 5 6V9C5 12.87 8.13 16 12 16C15.87 16 19 12.87 19 9V6C19 3.79 17.21 2 15 2ZM14.84 8.45L14.22 9.21C14.12 9.32 14.05 9.54 14.06 9.69L14.12 10.67C14.16 11.27 13.73 11.58 13.17 11.36L12.26 11C12.12 10.95 11.88 10.95 11.74 11L10.83 11.36C10.27 11.58 9.84 11.27 9.88 10.67L9.94 9.69C9.95 9.54 9.88 9.32 9.78 9.21L9.16 8.45C8.77 7.99 8.94 7.48 9.52 7.33L10.47 7.09C10.62 7.05 10.8 6.91 10.88 6.78L11.41 5.96C11.74 5.45 12.26 5.45 12.59 5.96L13.12 6.78C13.2 6.91 13.38 7.05 13.53 7.09L14.48 7.33C15.06 7.48 15.23 7.99 14.84 8.45Z" fill="currentColor" />
    //       <path opacity="0.4" d="M14.8402 8.45014L14.2202 9.21014C14.1202 9.32014 14.0502 9.54014 14.0602 9.69014L14.1202 10.6701C14.1602 11.2701 13.7302 11.5801 13.1702 11.3601L12.2602 11.0001C12.1202 10.9501 11.8802 10.9501 11.7402 11.0001L10.8302 11.3601C10.2702 11.5801 9.84024 11.2701 9.88024 10.6701L9.94023 9.69014C9.95023 9.54014 9.88023 9.32014 9.78023 9.21014L9.16023 8.45014C8.77024 7.99014 8.94024 7.48014 9.52024 7.33014L10.4702 7.09014C10.6202 7.05014 10.8002 6.91014 10.8802 6.78014L11.4102 5.96014C11.7402 5.45014 12.2602 5.45014 12.5902 5.96014L13.1202 6.78014C13.2002 6.91014 13.3802 7.05014 13.5302 7.09014L14.4802 7.33014C15.0602 7.48014 15.2302 7.99014 14.8402 8.45014Z" fill="currentColor" />
    //     </svg>
    //   ),
    //   text: 'Reward Hub',
    //   onClick: navigateTo(mockRoutes.rewards),
    // },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '4px' }}
          xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.4"
            d="M16.19 2H7.82002C4.18002 2 2.01001 4.17 2.01001 7.81V16.18C2.01001 19.82 4.18002 21.99 7.82002 21.99H16.19C19.83 21.99 22 19.82 22 16.18V7.81C22 4.17 19.83 2 16.19 2Z"
            fill="currentColor" />
          <path
            d="M9.16985 14.0899C9.35985 14.0899 9.54985 14.0199 9.69985 13.8699L14.0799 9.48992V11.9199C14.0799 12.3299 14.4199 12.6699 14.8299 12.6699C15.2399 12.6699 15.5799 12.3299 15.5799 11.9199V7.67992C15.5799 7.57992 15.5599 7.48992 15.5199 7.38992C15.4399 7.20992 15.2998 7.05993 15.1098 6.97993C15.0198 6.93993 14.9199 6.91992 14.8199 6.91992H10.5799C10.1699 6.91992 9.82985 7.25992 9.82985 7.66992C9.82985 8.07992 10.1699 8.41992 10.5799 8.41992H13.0098L8.62985 12.7999C8.33985 13.0899 8.33985 13.5699 8.62985 13.8599C8.78985 14.0199 8.97985 14.0899 9.16985 14.0899Z"
            fill="currentColor" />
          <path
            d="M18.7099 16.28C18.5799 15.89 18.1599 15.68 17.7599 15.81C14.0399 17.05 9.94993 17.05 6.22993 15.81C5.83993 15.68 5.40994 15.89 5.27994 16.28C5.14994 16.67 5.35994 17.1 5.74994 17.23C7.75994 17.9 9.86994 18.24 11.9899 18.24C14.1099 18.24 16.2199 17.9 18.2299 17.23C18.6299 17.09 18.8399 16.67 18.7099 16.28Z"
            fill="currentColor" />
        </svg>
      ),
      text: 'Log Out',
      onClick: handleLogout,
      className: 'text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20',
    },
  ];

  return (
    <div className="w-64 bg-white dark:!bg-[#121212] shadow-lg py-2">
      {loading && (
        <div className="px-4 py-2">
          <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
            <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            Loading...
          </div>
        </div>
      )}

      <div className="space-y-1">
        {menuItems.map((item, index) => (
          <MenuItem
            key={index}
            icon={item.icon}
            text={item.text}
            onClick={item.onClick}
            badge={item.badge}
            className={item.className || ''}
          />
        ))}
      </div>
    </div>
  );
}

// Dropdown/Popover wrapper component for easy integration
export const MenuPopupDropdown = ({
  isOpen,
  onClose,
  triggerRef
}: {
  isOpen: boolean;
  onClose: () => void;
  triggerRef: React.RefObject<HTMLElement>;
}) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });

  React.useEffect(() => {
    if (isOpen && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + 8,
        left: rect.left,
      });
    }
  }, [isOpen, triggerRef]);

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-40"
        onClick={onClose}
      />

      {/* Menu Popup */}
      <div
        className="fixed z-50 "
        style={{ top: position.top, left: position.left }}
      >
        <MenuPopupTailwind />
      </div>
    </>
  );
};

// Trigger button component
export const MenuTriggerButton = React.forwardRef<HTMLButtonElement, {
  onClick: () => void;
  user: any;
}>(({ onClick, user }, ref) => {
  return (
    <button
      ref={ref}
      onClick={onClick}
      className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors duration-200"
    >
      <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white font-medium">
        {user?.username?.charAt(0).toUpperCase() || 'U'}
      </div>
      <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </button>
  );
});

MenuTriggerButton.displayName = 'MenuTriggerButton';

// Complete dropdown component with state management
export const MenuPopupComplete = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [user] = useUserDetails();
  const triggerRef = React.useRef<HTMLButtonElement>(null);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <div className="relative">
      <div className="">

        <MenuTriggerButton
          onClick={toggleMenu}
          user={user}
          ref={triggerRef}
        />
        <MenuPopupDropdown
          isOpen={isOpen}
          onClose={closeMenu}
          triggerRef={triggerRef}
        />
      </div>
    </div>
  );
};
